import React from 'react';

const SlotSurvey = () => {
  return <div>Slot Survey...</div>;
};

export default SlotSurvey;
